import { render } from "./ProductsContent.vue?vue&type=template&id=56ce9af4&scoped=true&ts=true"
import script from "./ProductsContent.vue?vue&type=script&lang=ts"
export * from "./ProductsContent.vue?vue&type=script&lang=ts"

import "./ProductsContent.vue?vue&type=style&index=0&id=56ce9af4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ce9af4"]])

export default __exports__